import React, { useEffect, useState } from 'react'


import {  useNavigate } from 'react-router-dom'

import { useRequest } from 'hooks/useRequest'
import images from 'assets/images/images'
import { toast } from 'react-toastify'
import auth from 'utils/Auth'
import { stages } from 'utils/Constants';
import { useDispatch, useSelector } from 'react-redux'
import {  useEffectTrigger } from 'redux/features/general/generalSlice'
import LoaderTwo from 'pages/LoaderTwo'
import ReactStars from "react-rating-stars-component";
import useTranslate from 'hooks/useTranslate'
import useQuery from 'hooks/useQuery'

const StageBranch = ({ setRegisterState}) => {
	const {userChoises} = useSelector(state => state.general)
	const [data, setData] = useState()
    const dispatch = useDispatch();
	const [request, loading] = useRequest();
	const navigate = useNavigate();
	const {t } = useTranslate()
	let query = useQuery();
	useEffect(() => {
		request('/Restaurant', {
			method: 'GET',
			params: {
				//userAddressId: 38,
				userAddressId: (userChoises?.deliveryType == 2 && userChoises?.addressId) ? userChoises?.addressId : null,
				neighborhoodId: (userChoises?.deliveryType == 1 && userChoises?.neighbourhoodId) ? userChoises?.neighbourhoodId : null
			},
		}).then((res) => {
			if (res?.data) {
				setData(res.data.result)
			}
		})
	}, [])

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])


	// const anotherChannel = (item) => {
	// 	if (item?.channels?.length > 0 && item.regionId != 3) {
	// 		navigate('/channel/' + item.id)
	// 	}
	// }

    const restaurantStatus = (status) => {
       switch (status) {
        case 0:
            return t('restaurantOpen')
        case 1:
            return t('closed')
        case 2:
            return t('busy')
        default:
            return t('restaurantOpen')
       }
    }

	const goChannel = (dt) => {
		if(restaurantStatus(dt?.restaurantStatus) == t('restaurantOpen')){
			const addChoises = {regionId: dt?.regionId, restaurantId: dt?.id, restaurantName: dt?.name, minOrderAmount:dt?.minOrderAmount}
			auth.setUserChoises({...userChoises, ...addChoises})
			//forHome && dispatch(homeAddressReChoice({openStatus: false, step: null}))
			dispatch(useEffectTrigger(Math.floor(Math.random() * 1000)))
			navigate( query.get('returnUrl') ? `${query.get('returnUrl')}`:'/' )		
		}else if(restaurantStatus(dt?.restaurantStatus) == t('closed') &&  dt.channels.length > 0){
			auth.setUserChoises({...userChoises, channels: dt?.channels})
			//forHome && dispatch(homeAddressReChoice({openStatus: true, step: 3}))
			setRegisterState && setRegisterState(stages.STAGE_TAKEAWAY) 
		}else if(restaurantStatus(dt?.restaurantStatus) == t('closed') && dt.channels.length == 0 ){
			toast.error(t('outsideWorkingHours')) 
		}else if(restaurantStatus(dt?.restaurantStatus) == t('busy')){
			return toast.error(t('busyRestaurant'))
		}
	}

	return (
		<div className='stageBranch'>
		<LoaderTwo isDataLoading={loading} />
		<div className='stageBranch-container'>
        <div className='stageBranch-title'>
              <h1 className='stageBranch-title-one'>{userChoises?.deliveryType == 2 ? t('takeaway') : t('comeGetIt')}</h1>
              {data?.length > 0 && <div className='stageBranch-title-two'>{userChoises?.deliveryType == 2 ? t('selectAddressesText') : t('selectBranchesText')}</div>}
            </div>
             <div className=''>
                {
                  data?.length > 0 ? 
                  <div className='stageBranch-data'>
                     {data?.map((dt,i) => (
                        <div onClick={() => goChannel(dt)} className='stageBranch-data-item' key={i}>
                            <div className='stageBranch-data-item-left'>
                                <div className='stageBranch-data-item-left-title'>{dt?.name}</div>
                                <div className='stageBranch-data-item-left-date'>
                                  <img src={images.clock} alt="" />
                                  <div>{dt?.openTime?.slice(0, 5)} - {dt?.closeTime?.slice(0, 5)} • {restaurantStatus(dt?.restaurantStatus) == t('restaurantOpen') ? t('open') : restaurantStatus(dt?.restaurantStatus)} • {t('minimumOrderAmount')}: {dt?.minOrderAmount} TL</div>
                                </div>
								{dt?.googleMapsUrl && <a href={dt?.googleMapsUrl} onClick={e => e.stopPropagation()} target='_blank' className='stageBranch-data-item-left-maptitle' rel="noreferrer"> <img src={images.pinMapPrimary} alt="" /> {t('showOnMap')}</a>}
                            </div>
                            <div className='stageBranch-data-item-right'>
								<div className="stageBranch-data-item-right-point">
									<ReactStars
										halfIcon={<img className='stageBranch-data-item-right-point-star' src={images.starHalf}/>}
										filledIcon={<img className='stageBranch-data-item-right-point-star' src={images.starFill} />}
										emptyIcon={<img className='stageBranch-data-item-right-point-star' src={images.star} />}
										count={5}
										value={Number(dt.rating)}
										isHalf={true}
										edit={false}
									/>
									<div className="header-s">
										{Number(dt.rating).toFixed(1)}
									</div>
								</div>
                                <div className='distance'>{dt?.distance} KM</div>
                                <div className={`${restaurantStatus(dt?.restaurantStatus) == t('restaurantOpen') ?  "status-green": restaurantStatus(dt?.restaurantStatus) == t('closed') && dt?.channels?.length > 0 ? "status-green" :  "status-red"}`}>{restaurantStatus(dt?.restaurantStatus) == t('closed') && dt?.channels?.length > 0 ? restaurantStatus() :  restaurantStatus(dt?.restaurantStatus)}</div>
                            </div>
                        </div>
                     ))}
                  </div> 
					: loading 
					?<div className='stageBranch-data'>
						<div className="stageBranch-data-item">
							<div className=' skeleton p-4'></div>
						</div>
						<div className="stageBranch-data-item">
							<div className=' skeleton p-4'></div>
						</div>
					</div>
					: <div className='stageBranch-error'>{t('weCannotServeText')}</div> 
                   
                }
             </div>
        </div>

           
		</div>
	)
}

export default StageBranch
